import { render, staticRenderFns } from "./CRMAllCreate.vue?vue&type=template&id=8ca93f32&scoped=true&"
import script from "./CRMAllCreate.vue?vue&type=script&lang=js&"
export * from "./CRMAllCreate.vue?vue&type=script&lang=js&"
import style0 from "./CRMAllCreate.vue?vue&type=style&index=0&id=8ca93f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca93f32",
  null
  
)

component.options.__file = "CRMAllCreate.vue"
export default component.exports